import { PropsWithChildren } from 'react'
import tw, { TwStyle } from 'twin.macro'

const Card = ({ twStyle, children }: PropsWithChildren<{ twStyle?: TwStyle }>) => {
  return <div css={[tw`p-4 rounded-2xl bg-[var(--bg-landing-card)]`, twStyle]}>{children}</div>
}

const Text = ({ children, twStyle }: PropsWithChildren<{ twStyle?: TwStyle }>) => {
  return (
    <p css={[tw`text-[13px] leading-[18px] font-medium text-[#636366] dark:text-[#D1D1D6]`, twStyle]}>{children}</p>
  )
}

const CalcResultLabel = ({ children, twStyle }: PropsWithChildren<{ twStyle?: TwStyle }>) => {
  return <p css={[tw`text-sm font-medium text-[#636366] dark:text-[#D1D1D6]`, twStyle]}>{children}</p>
}

const CalcResultText = ({ children, twStyle }: PropsWithChildren<{ twStyle?: TwStyle }>) => {
  return <p css={[tw`text-sm font-semibold text-[#0F0F0F] dark:text-[#FFFFFF]`, twStyle]}>{children}</p>
}

export { CalcResultLabel, CalcResultText, Card, Text }
